<template>
    <div v-show="group.slots.length > 0">
        <select-menu :text="text" :values="values" v-model="local">
            Zeitraum
        </select-menu>
    </div>
</template>

<script>
import SelectMenu from "./UI/SelectMenu";

export default {
    name: "SlotSelect",

    components: {SelectMenu},

    inject: ['group'],

    props: ['value'],

    computed: {
        text() {
            return this.group.slots.map(slot => `${slot.name} (${slot.begin}-${slot.end} Uhr)`);
        },
        values() {
            return this.group.slots.map(slot => `${slot.begin}-${slot.end}`);
        },
        local: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    }
}
</script>

<style scoped>

</style>
